<script>
  import { Plugins } from "@capacitor/core";
  import { createEventDispatcher, onMount } from "svelte";

  const dispatch = createEventDispatcher();

  // video recording
  let stream;
  let recorder;
  let chunks = [];
  let video;

  // playback
  export let playbackVideo;
  let playbackVideoElem;

  // time
  export let time;
  let timeElapsed = 0;
  let timeInterval;

  $: timeRemaining = time - timeElapsed;

  $: formattedTime = [
    parseInt((timeRemaining / 60) % 60),
    parseInt(timeRemaining % 60),
  ]
    .join(":")
    .replace(/\b(\d)\b/g, "0$1");

  function prepare() {
    recorder = new MediaRecorder(stream, {
      mimeType: "video/webm;codecs=opus",
    });

    recorder.ondataavailable = (chunk) => {
      chunks.push(chunk.data);
      console.log(chunks);
      recorder = recorder;
    };
    recorder.onstart = () => {
      timeInterval = setInterval(() => (timeElapsed += 1), 1000);
      recorder = recorder;
      console.log("started");
    };
    recorder.onstop = () => {
      clearInterval(timeInterval);
      console.log("stopped");
    };
  }

  onMount(async () => {
    await Plugins.AtoDP.enumerateDevices();
    stream = await navigator.mediaDevices.getUserMedia({
      video: {
        height: {
          ideal: 720,
        },
        aspectRatio: {
          ideal: 1,
        },
      },
      audio: {
        sampleRate: {
          ideal: 48000,
        },
      },
    });

    video.srcObject = stream;
    video.muted = true;
    video.play();

    prepare();
  });

  let autoStop;

  async function stop() {
    clearInterval(autoStop);
    recorder.stop();
    if (playbackVideo) {
      playbackVideoElem.pause();
    }
  }

  async function start() {
    await Plugins.AtoDP.startScoModeIfNecessary();
    if (playbackVideo) {
      playbackVideoElem.currentTime = 0;
      playbackVideoElem.play();
    }
    recorder.start();
    recorder = recorder;
    autoStop = setTimeout(() => stop(), time * 1000);
  }

  async function toggle() {
    if (recorder?.state != "recording") {
      start();
    } else {
      stop();
    }
  }

  async function finish() {
    stream.getTracks().forEach((track) => track.stop());
    dispatch("finished", {
      video: new Blob(chunks, { type: chunks[0].type }),
      elapsed: timeElapsed,
    });
  }

  async function canceled() {
    stream.getTracks().forEach((track) => track.stop());
    dispatch("canceled");
  }

</script>

<!-- svelte-ignore a11y-media-has-caption -->
<video
  style="display: none;"
  bind:this={playbackVideoElem}
  src={playbackVideo}
/>

<main>
  <ion-button
    disabled={recorder?.state != "inactive"}
    on:click={canceled}
    fill="clear"
    color="dark"
    size="default"
  >
    <ion-icon name="arrow-back-outline" />
  </ion-button>

  <!-- svelte-ignore a11y-media-has-caption -->
  <video autoplay preload="auto" nocontrol bind:this={video} />

  {#if recorder}
    {#if timeElapsed > 0 && recorder?.state == "inactive"}
      <button class="record" on:click={finish}>
        <ion-icon name="checkmark-outline" />
      </button>
    {:else}
      <button
        class="record"
        on:click={toggle}
        class:active={recorder?.state == "recording"}
      >
        {recorder?.state == "recording" ? formattedTime : ""}
      </button>
    {/if}
  {/if}
</main>

<style>
  main {
    background: #000;
    height: 100vh;
    display: flex;
    flex-flow: column;
    align-items: center;
    box-sizing: border-box;
    padding: 30px 0;
  }

  main video {
    width: 100%;
    flex: 1;
  }

  main ion-button {
    align-self: flex-start;
    margin-left: 20px;
  }

  main button.record {
    outline: 0;
    border: none;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    background: rgba(255, 82, 82, 1);
    box-shadow: 0 0 0 5px rgba(255, 82, 82, 0.7);
    color: #fff;
    letter-spacing: 1px;
  }

  main button ion-icon {
    font-size: 30px;
  }

  main button.record.active {
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
    }

    10% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 20px rgba(255, 82, 82, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
    }
  }

</style>
